export default "__VITE_ASSET__DnQvkKH$__"